export const MAX_LOADING_ATTEMPTS = 2;
export const LOADING_ATTEMPT_TIMEOUT = 1500; // 1.5 sec
